"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _classnames = _interopRequireDefault(require("classnames"));

var CustomPropTypes = _interopRequireWildcard(require("../../constants/PropTypes"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

var _sizes = require("HubStyleTokens/sizes");

var _globalNavHeight = _interopRequireDefault(require("nav-meta/global-nav-height"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H1"));

var _H2 = _interopRequireDefault(require("UIComponents/elements/headings/H2"));

var _H3 = _interopRequireDefault(require("UIComponents/elements/headings/H4"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIGrid = _interopRequireDefault(require("UIComponents/grid/UIGrid"));

var _UIGridItem = _interopRequireDefault(require("UIComponents/grid/UIGridItem"));

var _UIButtonWrapper = _interopRequireDefault(require("UIComponents/layout/UIButtonWrapper"));

var _UIBox = _interopRequireDefault(require("UIComponents/layout/UIBox"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIMediaObject = _interopRequireDefault(require("UIComponents/layout/UIMediaObject"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UITruncateString = _interopRequireDefault(require("UIComponents/text/UITruncateString"));

var _UIResponsiveComponent = _interopRequireDefault(require("ecosystem-marketplace-core/components/UIResponsiveComponent"));

var _storefrontHeaderBlobs = _interopRequireDefault(require("bender-url!../../../img/storefront-header-blobs.svg"));

var _urls = require("../../utils/urls");

var _MainSectionInner = _interopRequireDefault(require("../layout/MainSectionInner"));

var _SearchSelect = _interopRequireDefault(require("./search/SearchSelect"));

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  && {\n    margin: auto;\n    width: 60%;\n\n    &.sticky {\n      width: 100%;\n    }\n\n    @media only screen and (min-width: ", ") and (max-width: ", ") {\n      width: 80%;\n    }\n\n    @media only screen and (max-width: ", ") {\n      width: 95%;\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  z-index: 9999;\n  transition: padding 0.2s ease;\n\n  &.sticky {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: ", ";\n    padding: 8px;\n    background-image: linear-gradient(-303deg, ", ", ", ");\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  padding: 0 48px;\n  margin: 0 -", ";\n  background-color: ", ";\n  background-image: url(", "),\n    linear-gradient(-303deg, ", ", ", ");\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-size: auto 100%;\n\n  &.sticky {\n    padding: 0 0 ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var getI18nKey = function getI18nKey(key) {
  return "appMarketplace.storefront.header." + key;
};

var StyledWrapper = _styledComponents.default.div.withConfig({
  displayName: "Header__StyledWrapper",
  componentId: "sc-1ypyrvq-0"
})(_templateObject(), _sizes.LAYOUT_PADDING_X, _colors.THUNDERDOME, _storefrontHeaderBlobs.default, _colors.THUNDERDOME, _colors.CALYPSO, _globalNavHeight.default);

var SearchSelectWrapper = _styledComponents.default.div.withConfig({
  displayName: "Header__SearchSelectWrapper",
  componentId: "sc-1ypyrvq-1"
})(_templateObject2(), _globalNavHeight.default, _colors.THUNDERDOME, _colors.CALYPSO);

var StyledGrid = (0, _styledComponents.default)(_UIGrid.default).withConfig({
  displayName: "Header__StyledGrid",
  componentId: "sc-1ypyrvq-2"
})(_templateObject3(), _sizes.GRID_BREAKPOINT_SMALL, _sizes.GRID_BREAKPOINT_LARGE, _sizes.GRID_BREAKPOINT_SMALL);

var Header = function Header(_ref) {
  var activeCategory = _ref.activeCategory,
      activeSuperCategory = _ref.activeSuperCategory,
      appIntegrations = _ref.appIntegrations,
      headingLevel = _ref.headingLevel,
      isCustomer = _ref.isCustomer,
      onSearchAppSelect = _ref.onSearchAppSelect,
      onSearchCategorySelect = _ref.onSearchCategorySelect,
      onSearchClear = _ref.onSearchClear,
      onSearchFeatureSelect = _ref.onSearchFeatureSelect,
      onSearchFilterSelect = _ref.onSearchFilterSelect,
      onSearchSubmit = _ref.onSearchSubmit,
      searchValue = _ref.searchValue,
      trackBeforeUnloadInteraction = _ref.trackBeforeUnloadInteraction;
  var searchBarContainer = (0, _react.createRef)();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isSticky = _useState2[0],
      setIsSticky = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      stickyOffsetTop = _useState4[0],
      setStickyOffsetTop = _useState4[1];

  var renderedHeading = (0, _react.useMemo)(function () {
    var isH2 = headingLevel === 'h2';
    var Heading = isH2 ? _H2.default : _H.default;
    var headingClasses = (0, _classnames.default)('text-center', {
      'is--heading-1': isH2
    });
    return _react.default.createElement(Heading, {
      className: headingClasses,
      style: {
        color: _colors.OLAF
      }
    }, _react.default.createElement(_FormattedMessage.default, {
      message: getI18nKey('headingText')
    }));
  }, [headingLevel]);
  (0, _react.useLayoutEffect)(function () {
    setStickyOffsetTop((0, _reactDom.findDOMNode)(searchBarContainer.current).offsetTop);
  }, []); // eslint-disable-line

  (0, _react.useEffect)(function () {
    var scrollHandler = function scrollHandler() {
      if (window.pageYOffset > stickyOffsetTop) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener('scroll', scrollHandler);
    return function () {
      window.removeEventListener('scroll', scrollHandler);
    };
  });
  return _react.default.createElement(StyledWrapper, {
    className: (0, _classnames.default)({
      sticky: isSticky
    }),
    "data-test-id": "storefront-header"
  }, _react.default.createElement(_MainSectionInner.default, {
    className: "p-top-7"
  }, _react.default.createElement(_UIFlex.default, {
    align: "center",
    direction: "column"
  }, _react.default.createElement(_UIBox.default, {
    alignSelf: "end"
  }, _react.default.createElement(_UIResponsiveComponent.default, {
    display: {
      xs: false,
      sm: true
    }
  }, _react.default.createElement(_UIButtonWrapper.default, null, _react.default.createElement(_UIButton.default, {
    href: (0, _urls.getConnectedAppsUrl)(isCustomer),
    onClick: function onClick() {
      trackBeforeUnloadInteraction('click manage apps button');
    },
    size: "extra-small",
    use: "primary-white"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: getI18nKey('manageButtonText')
  })), _react.default.createElement(_UIButton.default, {
    external: true,
    href: "https://developers.hubspot.com",
    iconProps: {
      className: 'hidden'
    },
    onClick: function onClick() {
      trackBeforeUnloadInteraction('click build button');
    },
    size: "extra-small",
    use: "primary-white"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: getI18nKey('buildButtonText')
  }))))), renderedHeading, _react.default.createElement("div", {
    className: "is--heading-5 m-bottom-8",
    style: {
      textAlign: 'center',
      color: _colors.OLAF
    }
  }, _react.default.createElement(_FormattedMessage.default, {
    message: getI18nKey('subheadingText')
  })))), _react.default.createElement(SearchSelectWrapper, {
    className: (0, _classnames.default)({
      'p-bottom-10': !isSticky,
      sticky: isSticky
    }),
    ref: searchBarContainer
  }, _react.default.createElement(_MainSectionInner.default, null, _react.default.createElement(StyledGrid, {
    className: (0, _classnames.default)({
      sticky: isSticky
    })
  }, isSticky && _react.default.createElement(_UIGridItem.default, {
    size: {
      xs: 2,
      md: 4,
      lg: 3
    }
  }, _react.default.createElement(_UIMediaObject.default, {
    align: "baseline",
    className: "p-top-2",
    itemLeft: _react.default.createElement(_UIIcon.default, {
      name: "sprocket",
      size: "xs",
      color: _colors.OLAF
    })
  }, _react.default.createElement(_H3.default, {
    "aria-level": 4,
    style: {
      color: _colors.OLAF
    },
    className: "m-bottom-0"
  }, _react.default.createElement(_UIResponsiveComponent.default, {
    display: {
      xs: false,
      sm: false,
      md: true
    }
  }, _react.default.createElement(_UITruncateString.default, null, _react.default.createElement(_FormattedMessage.default, {
    message: "appMarketplace.detail.header.rootBreadcrumbLinkText"
  })))))), _react.default.createElement(_UIGridItem.default, {
    className: "p-x-0",
    size: isSticky ? {
      xs: 10,
      md: 8,
      lg: 9
    } : 12
  }, _react.default.createElement(_SearchSelect.default, {
    activeCategory: activeCategory,
    activeSuperCategory: activeSuperCategory,
    appIntegrations: appIntegrations,
    isSticky: isSticky,
    onAppSelect: onSearchAppSelect,
    onCategorySelect: onSearchCategorySelect,
    onClear: onSearchClear,
    onFeatureSelect: onSearchFeatureSelect,
    onFilterSelect: onSearchFilterSelect,
    onSubmit: onSearchSubmit,
    searchValue: searchValue
  }))))));
};

Header.propTypes = {
  activeCategory: CustomPropTypes.category,
  activeSuperCategory: CustomPropTypes.superCategory,
  appIntegrations: _reactImmutableProptypes.default.orderedSet.isRequired,
  headingLevel: _propTypes.default.oneOf(['h1', 'h2']),
  isCustomer: _propTypes.default.bool.isRequired,
  onSearchAppSelect: _propTypes.default.func.isRequired,
  onSearchCategorySelect: _propTypes.default.func.isRequired,
  onSearchClear: _propTypes.default.func.isRequired,
  onSearchFeatureSelect: _propTypes.default.func.isRequired,
  onSearchFilterSelect: _propTypes.default.func.isRequired,
  onSearchSubmit: _propTypes.default.func.isRequired,
  searchValue: _propTypes.default.string,
  trackBeforeUnloadInteraction: _propTypes.default.func.isRequired
};
Header.defaultProps = {
  headingLevel: 'h1'
};
var _default = Header;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/storefront/Header.js
// module id = 746
// module chunks = 209 210 211 212